import { useState } from "react";

export function Tooltip({
  text,
  children,
}: {
  text: string;
  children: React.ReactNode;
}) {
  const [isVisible, setIsVisible] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0 });

  const handleMouseEnter = (e: React.MouseEvent<HTMLDivElement>) => {
    const rect = e.currentTarget.getBoundingClientRect();
    setPosition({
      top: rect.top,
      left: rect.left,
    });
    setIsVisible(true);
  };

  return (
    <>
      <div
        className="relative inline-block"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={() => setIsVisible(false)}
      >
        {children}
      </div>
      {isVisible && (
        <div
          className="fixed pointer-events-none"
          style={{
            zIndex: 9999,
            top: `${position.top}px`,
            left: `${position.left}px`,
            transform: "translateY(-100%)",
            marginTop: "-8px",
          }}
        >
          <div
            className="px-3 py-2 bg-gray-900 text-white text-sm rounded-lg shadow-lg"
            style={{
              maxWidth: "500px",
              whiteSpace: "normal",
              wordBreak: "break-word",
            }}
          >
            {text}
          </div>
          <div className="flex justify-center" style={{ marginTop: "-1px" }}>
            <div className="border-8 border-transparent border-t-gray-900"></div>
          </div>
        </div>
      )}
    </>
  );
}
